<template>
  <div>
    <template v-if="!json.init">
      <div
        v-if="jdata && jdata.areaImageUrl"
        class="spe-picture-hotspot"
        :style="{
          backgroundColor: jdata.commonStyle.usePageBackgroundColor ? jdata.commonStyle.bgColor : jdata.commonStyle.backgroundColor,
          backgroundImage: jdata.commonStyle.backgroundType == 2 ? `url(${jdata.commonStyle.backgroundImage})` : '',
          height: loadImgSuc ? 'auto' : `${px2Rem(areaH)}rem`,
        }"
        :ddt-area="`component_${json.floorId}`"
        ddt-expose="on">
        <div ref="hotspotArea" class="pic-wrap" :style="{margin: `0 ${px2Rem(jdata.commonStyle.margin)}rem`}">
          <img class="img" :src="jdata.areaImageUrl" @load="loadImg" />
          <!-- 自定义热区开始 -->
          <a
            v-for="(v, k) in jdata.pits"
            :key="k"
            :data-url="v.jumpLink"
            class="hotspot"
            :style="getHotspotStyle(v)"
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_图片热区组件.热区${k + 1}_点击跳转`"
            :data-desc="v.hotAreaName || ''"
            :dd_name="`${pt()}.component_${json.floorId}_图片热区组件.热区${k + 1}_点击跳转.${v.hotAreaName || ''}`"
            :ddt-click="`${pt()}.component_${json.floorId}_图片热区组件.热区${k + 1}_点击跳转.${v.hotAreaName || ''}`"
            :ddt-pit="`图片热区组件.热区${k + 1}`"
            :ddt-src="v.hotAreaName || ''"
            ddt-expose="on"
            @click.prevent.stop="toLink">{{v.hotAreaName}}</a>
          <!-- 自定义热区结束 -->
        </div>
      </div>
    </template>
    <div v-else :style="{height:`${px2Rem(json.height)}rem`}"></div>
  </div>
</template>

<script>
export default {
  name: 'spe-picture-hotspot',
  props: {
    json: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ['pt'],
  data(){
    return {
      rate: 1, // 缩放比
      areaW: 0, // 图片区域宽度
      areaH: 110, // 图片区域高度
      loadImgSuc: false // 图片是否加载完成
    }
  },
  computed: {
    jdata() {
      return this.json.data || { commonStyle: {}, areaHeight: 0, areaImageUrl: '', pits:[] }
    }
  },
  watch: {
    json: {
      async handler (newVal) {
        // 获取显示区域宽度
        await this.$nextTick(() => {
          const parentObj = this.$refs.hotspotArea
          if (!this.areaW) {
            const computedStyles = window.getComputedStyle(parentObj)
            this.areaW =
              parentObj.offsetWidth -
              (~~computedStyles.borderLeftWidth.replace('px', '') +
                ~~computedStyles.borderRightWidth.replace('px', ''))
          }
          if (newVal && newVal.data && newVal.data.areaImageUrl) {
            if (newVal.data.areaHeight) {
              const w = parentObj.offsetWidth
              this.rate = this.areaW / w
              this.areaH = newVal.height * this.rate 
            }
          } else {
            this.rate = 1
            this.areaH = 110 * this.rate
          }
        })
      },
      deep: true,
      immediate: false
    }
  },
  methods:{
    // px转换成rem
    px2Rem (px = 0) {
      px = ~~px
      let res = 0
      if (px) {
        res = px * 2 / 100
      }
      return res
    },
    // 转换热区数据
    getHotspotStyle ({areaHeight: h = 0, areaWidth: w = 0, areax: x = 0, areay: y = 0} = {}) {
      return {
        height: `${this.px2Rem(h * this.rate)}rem`,
        width: `${this.px2Rem(w * this.rate)}rem`,
        left: `${this.px2Rem(x * this.rate)}rem`,
        top: `${this.px2Rem(y * this.rate)}rem`
      }
    },
    // 跳转
    toLink (e) {
      const { url = '' } = (e && e.currentTarget && e.currentTarget.dataset) || {}
      if (url) {
        this.$sys.dict.href(url)
      }
    },
    // 图片加载成功后的回调，成功后将组件的高度去掉
    loadImg () {
      this.loadImgSuc = true
    }
  }
}
</script>

<style lang="less" scoped>
.spe-picture-hotspot{
  .pic-wrap {
    position: relative;
    .img {
      display: block;
      width: 100%;
      height: auto;
    }
    .hotspot {
      display: block;
      position: absolute;
      overflow: hidden;
      text-indent: -999rem;
      &:active {
        background-color: transparent;
      }
    }
  }
}
</style>
